import ModalContainer, { ModalContainerProps } from "components/common/ModalContainer";
import React, { useEffect } from "react";
import { ForecastNewProductContentProps } from "./types/ForecastNewProductStepForm";
import Button from "components/common/Button";
import clsx from "clsx";
import ForecastNewProductPlanResultGraph from "./ForecastNewProductPlanResultGraph";
import { useCoAgent } from "@copilotkit/react-core";
import { AgentType } from "enums/AgentTypeEnum";
import { isEmpty } from "lodash";
import { FORECAST_NEW_PRODUCT_STEP } from "./constant/ForecastNewProductStepConstant";
import { transformWeeklyToMonthlySales } from "helpers/transfromWeeksToMonthlySales";

type ForecastNewProductPlanResultProps = {} & ForecastNewProductContentProps &
    Omit<ModalContainerProps, "children">;

export default function ForecastNewProductPlanResult(props: ForecastNewProductPlanResultProps) {
    const { stepper, formik, tailwindClassName, ...rest } = props;

    const agent = useCoAgent<any>({
        name: AgentType.NewProductForecaster,
        config: {
            subgraphs: true,
            configurable: {
                ldbId: formik.values.ldbId,
                thread_id: formik.values.threadId,
            },
            limit: 50,
        },
    });

    const { state } = agent;
    const isEmptyState = isEmpty(state);
    const agentState = agent.state;

    useEffect(() => {
        if (agentState?.running) {
            stepper.go(FORECAST_NEW_PRODUCT_STEP.PLAN_LOADER);
        }
    }, [agentState?.running]);

    const adjustedForecast = agentState?.adjustedForecast || [];

    useEffect(() => {
        if (!!adjustedForecast && adjustedForecast?.length >= 1) {
            const salesData = transformWeeklyToMonthlySales(adjustedForecast);
            formik.setFieldValue("salesData", salesData);
        }
    }, [adjustedForecast]);

    console.log({ agentState });

    return (
        <ModalContainer {...rest} tailwindClassName={clsx("max-w-[720px]", tailwindClassName)}>
            <div>
                <div className="flex justify-between items-center px-[24px] py-[16px]">
                    <button
                        onClick={() => {
                            stepper.go(FORECAST_NEW_PRODUCT_STEP.PLAN_LIST);
                            formik.resetForm();
                        }}
                    >
                        <i className="ri-arrow-left-line"></i>
                    </button>

                    <p className="text-[18px]  font-rocGroteskMedium">Generated forecast result</p>

                    <button onClick={rest.closeModal}>
                        <i className="ri-close-line"></i>
                    </button>
                </div>

                <hr className="border-[#E2E8F0]" />

                <div className="p-[24px] max-h-[calc(100vh-150px)] overflow-y-auto">
                    <ForecastNewProductPlanResultGraph stepper={stepper} formik={formik} isEdit />
                </div>

                <hr className="border-[#E2E8F0]" />

                <div className="flex gap-[8px] px-[24px] py-[12px]">
                    <div />

                    <div className="flex-1"></div>
                    <Button
                        btnText="Cancel"
                        onClick={rest.closeModal}
                        btnClassname="!bg-[#F4F5F7] cursor-pointer !text-[13px] !px-[24px] !py-[12px] rounded-[5px] !h-[42px] w-min !whitespace-nowrap"
                    />
                    <Button
                        disabled={
                            isEmptyState || !adjustedForecast || adjustedForecast?.length === 0
                        }
                        isLoading={formik.isSubmitting}
                        btnText="Use this as forecast value for the new product"
                        onClick={() => {
                            formik.handleSubmit();
                        }}
                        btnClassname="!bg-[#0AAD0A] !text-white cursor-pointer !text-[13px] !px-[24px] !py-[12px] rounded-[5px] !h-[42px] w-min !whitespace-nowrap"
                    />
                </div>
            </div>
        </ModalContainer>
    );
}
